import { useSyncExternalStore } from 'react';
import { store } from './store';

/** Subscribe this component to every store change. Returns the version stamp. */
export function useStore(): number {
  return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
}
